var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NavigationButton } from '@/components/navigation-button.component';
import { Typography } from '@mui/material';
export function ErrorMessage(_a) {
    var action = _a.action, message = _a.message, actionText = _a.actionText;
    return (_jsxs("div", __assign({ className: "grid gap-4 place-items-center min-h-60 md:min-h-widget mt-12" }, { children: [_jsx(Typography, __assign({ className: 'md:text-4xl text-3xl font-bold' }, { children: message })), _jsx(NavigationButton, __assign({ onClick: action, className: "w-fit" }, { children: actionText }))] })));
}
